export const HOME_STATS = [
  { value: '15,200', label: 'People reached through outreach' },
  { value: '45+', label: 'Outreach events' },
  { value: '50+', label: 'Team members' },
  { value: '10+', label: 'Years active' }
];

export const HOME_SPONSORS = [
  { src: '/images/sponsors/sponsor/Momentus.png', name: 'Momentus' },
  { src: '/images/sponsors/sponsor/mda-logo.png', name: 'MDA' },
  { src: '/images/sponsors/sponsor/agi-logo.png', name: 'AGI' },
  { src: '/images/sponsors/sponsor/digikey.svg', name: 'DigiKey' },
  { src: '/images/sponsors/sponsor/valispace.png', name: 'Valispace' },
  { src: '/images/sponsors/sponsor/csa-logo.png', name: 'Canadian Space Agency' }
];

export const HOME_MISSIONS = [
  {
    to: '/projects/aleasat',
    name: 'ALEASAT',
    detail: 'Our flagship CubeSat',
    image: '/images/aleasat/finished-cube.jpg',
    alt: 'The assembled ALEASAT cube with blue test wiring, beside a small model cube'
  },
  {
    to: '/projects/balloon3',
    name: 'Balloon 3',
    detail: 'Launched from Carbon, Alberta',
    image: '/images/site/team-launch.jpg',
    alt: 'From the Balloon 3 mission'
  },
  {
    to: '/rover',
    name: 'Polaris',
    detail: 'Canadian International Rover Challenge',
    image: '/images/rover/sfusat-recruitment-poster.png',
    alt: 'Canadian International Rover Challenge logo',
    isLogo: true
  }
];
